import { render, staticRenderFns } from "./groupedCompactWall.vue?vue&type=template&id=4e8b6b40&scoped=true&"
import script from "./groupedCompactWall.vue?vue&type=script&lang=js&"
export * from "./groupedCompactWall.vue?vue&type=script&lang=js&"
import style0 from "./groupedCompactWall.vue?vue&type=style&index=0&id=4e8b6b40&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e8b6b40",
  null
  
)

export default component.exports